import Stack from "@mui/material/Stack";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";
import CallQueueItem from "./call-queue-item.component";

export default function CallItemsContainer() {
  const {
    callsQueue: { ids, details },
    displaySettings: { showQueue },
  } = useSunoDialer();

  return (
    <Stack
      width="100%"
      sx={{
        mt: 0.5,
        py: 0.5,
        borderRadius: "8px",
        maxHeight: "260px",
        overflowY: "auto",
        cursor: "default",
        minWidth: showQueue ? "447px" : undefined,
      }}
    >
      {ids.map((id) => (
        <CallQueueItem key={id} item={details[id]} />
      ))}
    </Stack>
  );
}
